export const styles = () => ({
  select: {
    width: { tablet: '250px', mobile: '100%' },
  },
});

export default styles;
